<template>
    <div 
        class="scene_container"
        v-on:click.self="(e) => {clearActiveElements(e)}"
    >
        <div class="projectId" v-if="getSessionDetails.mode === 'merchant'">
            {{ $t('editorSceneProjectId') }} {{ getProject.id }}
        </div>
        <div class="pages" @wheel="(e) => {addScroll(e)}">
            <div
            class="pages_viewport"
            style="position:absolute;"
            id="pages_viewport"
            
            v-on:click.self="(e) => {clearActiveElements(e)}"
        >
            <PageWorkSheet
                v-for="(page, index) in getPages"
                :key="page.content.id"
                :pageIndex="index"
                :page="page"
                ref="pageWorkSheet"
            />
        </div>

        </div>
        
    </div>
</template>

<script>
    import { uuid } from 'vue-uuid';
    import { mapGetters } from 'vuex';
    import PageWorkSheet from './Page/PageWorkSheet.vue';
    import { RepositoryFactory } from '../../repositories/repositoryFactory';
    const ProjectRepository = RepositoryFactory.get('projects');
    import { qrSvg } from '../../js/qrCodeSvg';

    export default {
        data() {
            return {
                isMoving: false
            }
        },
        methods: {
            clearActiveElements(e) {
                this.$store.dispatch('DISABLE_ELEMENTS_ON_PAGE');
            },
            addScroll(e) {
                if (this.isMoving) {
                    return;
                }

                let change = 0;

                if (e.deltaY > 0 && this.getPageTransition < this.getPages.length - 1) {
                    change = 1;
                }
                if (e.deltaY < 0 && this.getPageTransition > 0) {
                    change = -1;
                }

                if (change === 0) {
                    return;
                }

                this.$store.dispatch('CHANGE_PAGE_TRANSITION', this.getPageTransition + change);
                this.$store.dispatch('DISABLE_ELEMENTS_ON_PAGE');
                this.$store.dispatch('SET_CURRENT_PAGE', this.getPages[this.getPageTransition].content.id);

                const pages = this.$children;
                const that = this;
                
                pages.forEach(page => {
                    this.isMoving = true;
                    page.$el.style.transform = 'translateY(-'+this.getPageTransition*100+'%)';
                    page.$el.addEventListener('transitionend', function endTransition() {
                        that.isMoving = false;
                        page.$el.removeEventListener('transitionend', endTransition, true);
                    });
                });
            },
            elements() {
                const pages = this.getPages;
                let elements = [];
                pages.forEach(page => {
                    const placeholderUserInputs = page.content.elements.filter(element => element.placeholder !== undefined).filter(element => element.placeholder.hasPlaceholder === true);
                    elements = [...elements, ...placeholderUserInputs]
                });

                let placeholders = elements.map(el => ({
                    placeholderObj: el.placeholder,
                    content: el.content,
                    ids: [],
                    hasError: false,
                    errorMessage: null
                }));
                
                placeholders = placeholders.map(placeholder => {
                    const placeholderSystemName = placeholder.placeholderObj.placeholderSystemName;

                    const elementsForPlaceholders = elements.filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);

                    let ids = [];
                    elementsForPlaceholders.forEach(el => ids.push(el.id));
                    
                    return {
                        ...placeholder,
                        ids
                    }
                })

                let uniquePlaceholders = placeholders.filter((el, i, arr) => {
                    return arr.findIndex(obj => obj.placeholderObj.placeholderId === el.placeholderObj.placeholderId) === i
                });

                uniquePlaceholders.map(placeholder => {
                    const newestPlaceholderValues = this.getPlaceholders.find(item => item.id === placeholder.placeholderObj.placeholderId).name;
                    placeholder.placeholderObj.placeholderName = newestPlaceholderValues;
                });

                return uniquePlaceholders;
            },
            asyncFunction(page) {
                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.getSessionDetails.token
                };
                const that = this;

                return new Promise((resolve, reject) => {
                    ProjectRepository.getProjectPage(that.getProject.id, page.number, headers)
                    .then(result => {
                        const hasContent = result.data.data.content === null ? false : true;
                        const elements = hasContent ? result.data.data.content.elements : [];
                        elements.forEach(element => {
                            if (element.type === "TEXT_ELEMENT") {
                                const hasPlaceholder = Object.keys(element).includes('placeholder');
                                const placeholder = hasPlaceholder ? element.placeholder : {
                                    hasPlaceholder: false,
                                    placeholderId: 'noPlaceholder',
                                    placeholderSystemName: 'noPlaceholder'
                                };

                                element = {
                                    ...element,
                                    placeholder
                                }

                                if (that.getSessionDetails.mode === 'user') {
                                    if (placeholder.placeholderSystemName !== 'noPlaceholder') {
                                        const placeholderSystemName = element.placeholder.placeholderSystemName;
                                        const placeholderValue = that.getSessionDetails.placeholderValues[placeholderSystemName].value;
                                        const content = placeholderValue !== null ? placeholderValue : element.content;

                                        element = {
                                            ...element,
                                            content
                                        }
                                    }
                                }                                
                            }

                            if (element.type === "PHOTO_CELL_ELEMENT") {
                                const hasSvgBoolean = Object.keys(element.maskImg).includes('isFromSvg');

                                const maskImg = hasSvgBoolean ? element.maskImg : {
                                    ...element.maskImg,
                                    isFromSvg: false
                                };

                                element = {
                                    ...element,
                                    maskImg
                                }
                            }

                            const hasLockedValue = Object.keys(element).includes('isLocked');
                            const hasNewTransforms = Object.keys(element).includes('newTransforms');
                            const isLocked = hasLockedValue ? element.isLocked : false;
                            const newTransforms = hasNewTransforms ? element.newTransforms : false;

                            const payload = {
                                elData: {
                                    ...element,
                                    isActive: false,
                                    isLocked,
                                    newTransforms
                                },
                                fromProject: true
                            }

                            that.$store.dispatch('ADD_PAGE_ELEMENT', payload).then(() => {
                                if (element.type === "QR_CODE_ELEMENT") {
                                    qrSvg(element.content, element.frontColor, element.backColor, element.width, element.id);
                                }
                            });
                        });

                        that.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', that.elements());

                        resolve();
                    });
                });
            }
        },
        computed: {
            ...mapGetters([
                'getPages',
                'getProject',
                'getPageTransition',
                'getSessionDetails',
                'getPlaceholders'
            ])
        },
        created() {
            let promiseArray = this.getPages.map(this.asyncFunction);

            Promise.all(promiseArray).then(results => {
                this.$store.dispatch('ALL_ELEMENTS_LOADED');
            });
        },
        mounted() {
            this.$store.dispatch('CHANGE_PAGE_TRANSITION', 0);
        },
        components: {
            PageWorkSheet
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .scene_container {
        // display: flex;
        // flex-direction: column;
        // flex-grow: 1;
        width: 100%;
        height: 100%;
        position: relative;
        box-sizing: border-box;
        // overflow: hidden;
        // overflow-y: scroll;
        // top: 0;
        // right: 0;
        // bottom: 0;
        // left: 0;
    }
    // .pages_viewport::-webkit-scrollbar {
    //     display: block;
    //     width: 10px;
    // }
    // .pages_viewport::-webkit-scrollbar-track {
    //     background: transparent;
    //     border-radius: 5px;
    // }
    // .pages_viewport::-webkit-scrollbar-thumb {
    //     background-color: #d3d2d3;
    //     border-right: none;
    //     border-left: none;
    //     border-radius: 25px;
    // }
    // .pages_viewport::-webkit-scrollbar-track-piece:end {
    //     background: transparent;
    //     margin-bottom: 10px; 
    // }
    // .pages_viewport::-webkit-scrollbar-track-piece:start {
    //     background: transparent;
    //     margin-top: 50px;
    // }
    .pages {
        // flex-grow: 1;
        position: relative;
        width: 1100px;
        height: 100%;
        // overflow-y: hidden;
    }
    // @media (max-width: 1500px) {
    //     .pages {
    //         width: 900px;
    //         height: 90%;
    //         top: 5%;
    //         margin: auto;
    //     }
    // }
    .pages_viewport {
        // position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        // box-sizing: border-box;
        padding: 100px 30px;
        // overflow: hidden;
        // overflow-y: scroll;
        
    // max-height: 80vh;
    }
    // @media (max-width: 1500px) {
    //     .pages_viewport {
    //         padding: 30px;
    //     }
    // }
    .page_new button {
        margin: 20px auto 40px auto;
        width: 300px;
        display: block;
        border: 2px solid #D4D4D4;
        border-radius: 8px;
        padding: 8px;
        background-color: transparent;
        color: #656565;
        cursor: pointer;
    }
    .projectId {
        position: absolute;
        top: 40px;
        color: #737373;
    }
    @media (max-width: 1200px) {
        .pages {
            width: 800px;
        }
        .pages_viewport {
            padding: 30px;
        }
    }
</style>